<template>
  <ComDialog
    :isShow="dialogVisible"
    :width="400"
    :title="t('执行命令')"
    alignCenter
    @close="handleClose"
  >
    <el-form ref="formRef" :model="formData" :rules="rules">
      <el-form-item label="命令" prop="command">
        <el-input
          type="textarea"
          v-model="formData.command"
          rows="4"
          placeholder="请输入执行命令"
          required
        />
      </el-form-item>
    </el-form>
    <div class="dialog-footer">
      <el-button type="primary" :loading="loading" :disabled="loading" @click="submitForm">提交</el-button>
    </div>
  </ComDialog>
</template>
<script setup>
import { ref, defineExpose, defineEmits, nextTick } from "vue";
import ComDialog from "@/components/comDialog/index.vue";
import { useI18n } from "vue-i18n";
const { t } = useI18n();
import request from "@/utils/request.ts";
import API_CONFIG from "../api.json";
import { ElMessage } from "element-plus";
const emit = defineEmits(["freshLoad"]);
const loading = ref(false);
const dialogVisible = ref(false);
const formRef = ref(null);
const currentData = ref([]);
const formData = ref({
  command: ""
});
const rules = ref({
  command: [{ required: true, message: "请输入shell命令", trigger: "blur" }]
});

const open = data => {
  currentData.value = data;
  formData.value = { command: "" };
  dialogVisible.value = true;
  nextTick(() => {
    formRef.value.clearValidate();
  });
};
const handleClose = () => {
  dialogVisible.value = false;
};

const submitForm = async () => {
  const valid = await formRef.value.validate();
  if (!valid) return;
  loading.value = true;
  request
    .post(API_CONFIG.executeShellCommand.url, {
      ctrAlias: currentData.value.code,
      command: formData.value.command
    })
    .then(res => {
      if (res.code == 200) {
        ElMessage.success("执行shell命令成功");
        emit("freshLoad");
        dialogVisible.value = false;
      } else {
        ElMessage.error(res.msg);
      }
    })
    .finally(() => {
      loading.value = false;
    });
};

defineExpose({ open });
</script>
<style lang="scss" scoped>
.dialog-footer {
  text-align: center;
}
</style>